"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// default branch timing in 24 hrs format
// eg. when no branch is selected
// follows the object structure from branch factory
// when no branch is selected the time slots are 24 hrs
exports.default = {
    start24: '00:00',
    end24: '23:30',
    start: '12:00 AM',
    end: '11:30 PM',
};
